import React, {useEffect, useReducer, useState} from 'react';
import PropTypes from 'prop-types';
import VirtualKioskSettings from "./VirtualKioskSettings";
import useStarfishAPI from "hooks/useStarfishAPI";
import {urlParams} from "utils/request";
import {isEmptyString} from "utils/text";
import {SFEntityID} from "utils/types";
import {
    initialKioskSettings,
    kioskSettingsReducer,
    slotStateChangeCallbacks,
    withoutScheduleErrors
} from "./virtual-kiosk-settings-state";

// Fetches and saves virtual kiosk settings for Tenant Admins
const App = (props) => {
    const [getResponse, callGetAPI] = useStarfishAPI({isNewAPI: true});
    const [saveResponse, callSaveAPI] = useStarfishAPI({isNewAPI: true});

    const [isOpen, setIsOpen] = useState(true);
    const [state, dispatch ] = useReducer(kioskSettingsReducer, initialKioskSettings);

    useEffect(() => {
        const params = urlParams({id: props.kioskId})
        callGetAPI(`../api/virtual-kiosk-settings.json?${params}`, {
            method: 'GET'
        });
    }, []);

    useEffect(() => {
        if(getResponse.success) {
            dispatch({ type: 'LOAD_SETTINGS', elements: getResponse.data });
        } else if(getResponse.error) {
            dispatch({ type: 'ERROR', elements: getResponse.error });
        }
    }, [getResponse]);

    const saveVirtualCheckInSettings = () => {
        dispatch({ type: 'VALIDATE', submit: true});
        if(kioskSettingsReducer(state, {type: 'VALIDATE', submit: true}).error)
            return;

        callSaveAPI('../api/virtual-kiosk-settings.json', {
            method: 'POST',
            headers: {
                'Content-Type': "application/json"
            },
            body: JSON.stringify({
                kioskId: props.kioskId,
                virtualCheckInEnabled: state.virtualCheckInEnabled,
                virtualCheckInScheduleEnabled: state.virtualCheckInScheduleEnabled,
                virtualCheckInHoursSchedule: withoutScheduleErrors(state.virtualCheckInHoursSchedule)
            })
        });
    }

    const closeSettingsModal = (message) => {
        setIsOpen(false);
        props.onClose(message);
    }

    useEffect(() => {
        if(saveResponse.success) {
            closeSettingsModal("Kiosk settings successfully saved.");
        } else if(saveResponse.error) {
            dispatch({ type: 'ERROR', elements: saveResponse.error });
        }
    }, [saveResponse]);

    if(getResponse.pending || getResponse.data.length === 0)
        return <div>Loading...</div>;

    const showErrorOrInformation = (newState) =>
        newState.error ? newState.error : newState.informationalMsg;

    return (
        <VirtualKioskSettings isOpen={isOpen}
                              kioskName={props.kioskName}
                              abbreviatedTZ={state.abbreviatedTZ}
                              checkInSchedule={state.virtualCheckInHoursSchedule}
                              error={showErrorOrInformation(state)}
                              disableSave={!isEmptyString(state.error)}
                              timezone={state.timezone}
                              virtualCheckInEnabled={state.virtualCheckInEnabled}
                              virtualCheckInScheduleEnabled={state.virtualCheckInScheduleEnabled}
                              setVirtualCheckInScheduleEnabled={(values) =>
                                  dispatch({type: 'SET_VALUE', elements: { virtualCheckInScheduleEnabled: values }})
                              }
                              setVirtualCheckInEnabled={(values) =>
                                  dispatch({type: 'SET_VALUE', elements: { virtualCheckInEnabled: values }})
                              }
                              modifyCheckInSchedule={slotStateChangeCallbacks(dispatch)}
                              saveSettings={() => saveVirtualCheckInSettings()}
                              closeModal={() => closeSettingsModal('')} />
    );
}

App.propTypes = {
    kioskId: SFEntityID,
    kioskName: PropTypes.string,
    onClose: PropTypes.func
}
export default App;
